define('loginVueApp/login-vue-app',[
  'Vue',
  'vuex',
  'moment',
  'es6-promises',
  'es6-promises-auto',
], function (Vue, Vuex) {
  Vue.use(Vuex);

  return function (params) {
    Vue.mixin({
      data: function () {
        return {
          localization: app.localization,
          customization: app.customization,
          requireOrShowFields: app.customization.requireOrShowFields
        };
      },
      methods: {
        a11yKeyDown: function (e, handlers) {
          switch (e.keyCode) {
            case 38:
              handlers.up && handlers.up();
              break;
            case 40:
              handlers.down && handlers.down();
              break;
            case 37:
              handlers.left && handlers.left();
              break;
            case 39:
              handlers.right && handlers.right();
              break;
            case 13:
              handlers.enter && handlers.enter();
              break;
            case 9:
              if (e.shiftKey) {
                handlers.shiftTab && handlers.shiftTab();
              } else handlers.tab && handlers.tab();
              break;
            case 32:
              handlers.space && handlers.space();
            case 27:
              handlers.escape && handlers.escape();
          }
        },
      },
    });

    require(['loginVueApp/routes', 'app/views/vue/store/store' ], function (routes, store) {
      var vm = new Vue({
        el: '#login-vue-app',
        store: store,
        beforeMount: function () {
            if (app.data.resetVueApp) {
                app.datal('resetVueApp', false);
                this.$store.commit('setCurrentRoute', {currentRoute: 'profile'});
            }
        },
        computed: _.extend(Vuex.mapState(['currentRoute']), {
            ViewComponent: function() {
              var matchingView = routes()[
               params.route || this.currentRoute
              ];
              return matchingView;
            }
        }),
        render: function(h) {
          return h(this.ViewComponent);
        },
      });
      app.datal('vueLoginAppRef', vm);
    });
  };
});

